import { useMemo } from 'react';
import { useGetDocumentTypes } from '@/services/apis/queries/document-types/use-get-document-types';

export function useDocumentTypeIdByCode(
  documentTypeCode: string | undefined,
): string | null {
  const { data: documentTypes } = useGetDocumentTypes();

  return useMemo(() => {
    if (!documentTypeCode) {
      return null;
    }

    const matched = documentTypes?.find(
      (documentType) => documentType.code === documentTypeCode,
    );

    return matched ? String(matched.id) : null;
  }, [documentTypes, documentTypeCode]);
}
